import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import routes from "../../../constants/routes";
import { getDataTokenCreate, convertAmountFromRawNumber } from "../../../utils/Helpers";

const CreateToken4 = () => {
  const { t } = useTranslation();
  const { account, mnemonic } = useSelector((state) => state.account);

  const [form, setForm] = useState({
    token_name: "",
    short_name: "",
    total_supply: 0,
    owner: "",
    token_contract: "",
  });
  useEffect(() => {
    if (account) {
      const data = getDataTokenCreate();
      setForm((prev) => ({
        ...prev,
        ...data,
      }));
    } else {
      history(routes?.dashboard);
    }
  }, [account]);

  const handleCopy = () => {
    navigator.clipboard.writeText(form.token_contract);
  };

  return (
    <div className="pages-createToken4">
      <div className="box">
        <div className="top">
          <div className="left">{t("createToken.My Token")}</div>
          <Link to={routes.createToken3} className="right g-buttonHover">
            {t("createToken.Back")}
          </Link>
        </div>
        <div className="infoGroup">
          <div className="name">Token Name</div>
          <div className="content">{form.token_name}</div>
        </div>
        <div className="infoGroup">
          <div className="name">Token Contract Address</div>
        </div>
        <div className="text">{form.token_contract}</div>
        <div className="infoGroup">
          <div className="name">Token Symbol</div>
          <div className="content">{form.short_name}</div>
        </div>
        <div className="infoGroup">
          <div className="name">Total Supply</div>
          <div className="content">{convertAmountFromRawNumber(form.total_supply)}</div>
        </div>
        <div className="infoGroup">
          <div className="name">Icon</div>
          <div className="content">
            <img
              src={"https://www.gravatar.com/avatar/" + form.token_contract + "?s=128&d=identicon"}
              alt=""
            />
          </div>
        </div>
        <div className="copy" onClick={handleCopy}>
          {t("createToken.Copy")} <img src="/images/copy.svg" alt="" />
        </div>
      </div>
    </div>
  );
};

export default CreateToken4;
